import React from "react";
import PageButton from "../../components/PageButton/PageButton";

//import Assets
import success from "../../assets/icons/success.png";

//React Router
import { Link } from "react-router-dom";

//Style

import "./successfulReservation.scss";

const SuccessfulReservation = () => {
  return (
    <div className="successfulReservation__container">
      <div className="successfulReservation__message">
        <img src={success} alt="exito" />
        <p className="successfulReservation__message__title">
          ¡Muchas gracias!
        </p>
        <p className="successfulReservation__message__text">
          Su reserva se ha realizado con éxito.
        </p>
        <Link to={`/home`}>
          <PageButton
            filled
            className="successfulReservation__message__button"
            label="Aceptar"
          />
        </Link>
      </div>
    </div>
  );
};

export default SuccessfulReservation;
